module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Gb-Hc-Ib-Jb.f071224a.png";